import { render, staticRenderFns } from "./expertcenter.vue?vue&type=template&id=2523c0d6&scoped=true&"
import script from "./expertcenter.vue?vue&type=script&lang=js&"
export * from "./expertcenter.vue?vue&type=script&lang=js&"
import style0 from "./expertcenter.vue?vue&type=style&index=0&id=2523c0d6&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2523c0d6",
  null
  
)

export default component.exports